import ReactModal from 'react-modal'
import React from 'react'

import { CommunityConfig } from '~/service'
import { PageLoader } from '../loader'
import { NotFound } from '../not-found'
import styles from './MainLayout.module.scss'
import { Footer } from '~/components/layouts/Footer'
import { setThemeColors } from '~/util'
import { Nilable } from 'tsdef'

interface MainProps {
  children: (config: CommunityConfig) => React.ReactNode
  header: React.ReactNode
  config: CommunityConfig
}

const Main = React.memo(({ header, children, config }: MainProps) => {
  const rootRef = React.createRef<HTMLDivElement>()

  React.useEffect(() => {
    ReactModal.setAppElement(rootRef.current!)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    setThemeColors(config.primaryColor, config.secondaryColor)
  }, [config.primaryColor, config.secondaryColor])

  return (
    <div data-test="Main" className={styles.MainLayout} ref={rootRef}>
      {header}
      <div className={styles.pageContent}>{children(config)}</div>
      <Footer
        communityName={config.communityName}
        communityPhoneNumber={config.voicePhoneNumber}
        communityEmail={config.email}
        communityWebsite={config.url}
        licenseNumber={config.licenseNumber}
        communityContactName={config.smsContactName}
        communitySmsPhoneNumber={config.smsPhoneNumber}
      />
    </div>
  )
})

interface MainLayoutProps extends Omit<MainProps, 'config'> {
  isLoading: boolean
  isError: boolean
  config?: Nilable<CommunityConfig>
}

export function MainLayout({
  isLoading,
  isError,
  config,
  children,
  header,
}: MainLayoutProps) {
  if (isLoading) {
    return <PageLoader />
  } else if (isError || !config) {
    return <NotFound phoneNumber={config?.voicePhoneNumber} lostThing="page" />
  } else {
    return (
      <Main header={header} config={config}>
        {children}
      </Main>
    )
  }
}
